import {FC} from 'react';
import AdvisorProfileError from '@/components/advisor-profile-error';
import AppShell from '@/components/app-shell';
import {ErrorFallback} from '@/components/error-fallback';

const Unavailable: FC = () => (
  <AppShell>
    <ErrorFallback>
      <AdvisorProfileError />
    </ErrorFallback>
  </AppShell>
);

export default Unavailable;
